export default __webpack_public_path__ + "static/media/Rodolfo2.aa2c4e69.png";